import React from "react";
import PublicPage from "./PublicPage";

export default function About() {
    return (
        <PublicPage kicker="&gt; about.vyaahar" title="Built by finance operators for finance operators." testid="page-about">
            <p>
                Vyaahar is a cloud accounting platform for Indian SMBs and growing companies. Books, invoicing,
                bank reconciliation, GST, and an AI Copilot that queries your live ledger — in one workspace.
            </p>
            <p>
                We're a small team based out of Chennai. The founders spent a decade running finance and ops at
                consumer and B2B companies before starting Vyaahar. We got tired of stitching four tools together
                and paying for three of them just to close a month.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.4rem", marginTop: 32, color: "var(--vy-navy)" }}>Who we're for</h2>
            <ul>
                <li>Founders and CFOs of Indian SMBs who file GST every month.</li>
                <li>CAs and finance consultants managing multiple client books.</li>
                <li>Growing companies that outgrew spreadsheets but don't want an ERP.</li>
            </ul>
            <h2 className="vy-serif" style={{ fontSize: "1.4rem", marginTop: 32, color: "var(--vy-navy)" }}>Company</h2>
            <p>
                Vyaahar is a product of Scitus.ai — operated by
                Vyastics Technologies Private Limited, incorporated in India. For anything else, write to
                {" "}<a href="mailto:hello@scitus.ai" style={{ color: "var(--vy-gold)" }}>hello@scitus.ai</a>.
            </p>
        </PublicPage>
    );
}
